import baseRoute from '../baseRoute';

export type * from './requestModel';

type RouteDefinition = `${typeof baseRoute}/${number | ':toolId'}/changeLocation`;

export const ROUTE: RouteDefinition = `${baseRoute}/:toolId/changeLocation`;

export const URL = (toolId: number): RouteDefinition => `${baseRoute}/${toolId}/changeLocation`;
